'use strict'

import './_polyfills.js'

import 'lazysizes/plugins/parent-fit/ls.parent-fit.js'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes'
// import 'focus-visible'

import conditioner, { screen, idle } from '@parallaxagency/conditioner'
import screens from '../../tailwind.screens.js'

conditioner.addPlugin({
  moduleSetName: name => `./components/${name}.js`,
  moduleGetConstructor: module => module.default,
  moduleImport: name =>
    import(/* webpackChunkName: 'conditioner' */ `${name}`)
})
conditioner.addPlugin(screen(screens))
conditioner.addPlugin(idle)
conditioner.hydrate(document.documentElement)

if (process.env.NODE_ENV !== 'production') {
  import(
    /* webpackChunkName: "BrowserGrid" */ '@parallaxagency/browsergrid'
  ).then(({ BrowserGrid }) => {
    // eslint-disable-next-line no-unused-vars
    const browserGrid = new BrowserGrid([
      {
        width: 1280 + 30,
        cols: 12,
        gutter: 15,
        includeCenterLines: 6
      }
    ])
  })
}



// WEBPACK FOOTER //
// ./src/js/main.js